import "../styles/adminContactStyles.css";
const formatDateTime = (dateString) => {
  if (!dateString) return "";

  const date = new Date(dateString);

  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const period = hours >= 12 ? "PM" : "AM";

  hours = hours % 12 || 12;
  hours = String(hours).padStart(2, "0");

  return (
    <>
      {month}-{day}-{year} {hours}:{minutes} {period}
    </>
  );
};
const ContactRightPanel = ({selectedContact, setContactDetails}) => {
  return (
    <div className="col-sm-3 right-panel">

  <div className="info-row">
    <div>Status:</div>
    <div>{selectedContact.webStatusName || ""}</div>
  </div>

  <div className="info-row">
    <div>2FA Status:</div>
  <div>
    <select
  className="form-control input-sm"
  value={selectedContact?.isDuoActivated ? "true" : "false"}
  onChange={(e) =>
    setContactDetails((prev) => ({
      ...prev,
      isDuoActivated: e.target.value === "true",
    }))
  }
>
  <option value="false">No</option>
  <option value="true">Yes</option>
</select>
  </div>
  </div>

  <div className="info-row">
    <div>Created Date:</div>
    <div>{formatDateTime(selectedContact.createdDate || "")}</div>
  </div>

  <div className="info-row">
    <div>Last Synced:</div>
    <div>{formatDateTime(selectedContact.lastUpdateDate || "")}</div>
  </div>

  <div className="info-row">
    <div>Last Login On:</div>
    <div>{formatDateTime(selectedContact.lastLoginDate || "")}</div>
  </div>

  <div className="info-row">
    <div>Internal Contact ID:</div>
    <div>{selectedContact.webUserId || ""}</div>
  </div>

  <div className="checkbox small-checkbox">
    <label>
      <input
        type="checkbox"
        disabled
        checked={selectedContact.isPasswordSet}
      />
      Contact has set a Password
    </label>
  </div>

  <div className="checkbox small-checkbox">
    <label>
      <input
        type="checkbox"
        disabled
        checked={selectedContact.isSecurityQuestionsSet}
      />
      Contact has set 3 Security Questions
    </label>
  </div>

</div>
  );
};

export default ContactRightPanel;